/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tracks_OverlineInputs */

const en_cp_tracks_overline = /** @type {(inputs: Cp_Tracks_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TWO TRACKS, ONE LOOP`)
};

const id_cp_tracks_overline = /** @type {(inputs: Cp_Tracks_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DUA JALUR, SATU LOOP`)
};

/**
* | output |
* | --- |
* | "TWO TRACKS, ONE LOOP" |
*
* @param {Cp_Tracks_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tracks_overline = /** @type {((inputs?: Cp_Tracks_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tracks_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tracks_overline(inputs)
	return en_cp_tracks_overline(inputs)
});